var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from "vue-property-decorator";
import Modal from "./Modal.vue";
var BaseModal = /** @class */ (function (_super) {
    __extends(BaseModal, _super);
    function BaseModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseModal.prototype.close = function () {
        this.$emit("close");
    };
    __decorate([
        Prop()
    ], BaseModal.prototype, "show", void 0);
    BaseModal = __decorate([
        Component({
            components: {
                Modal: Modal
            }
        })
    ], BaseModal);
    return BaseModal;
}(Vue));
export default BaseModal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/shared/components/BaseModal.vue
// module id = 25
// module chunks = 0 1 2 3 4